export default "__VITE_ASSET__COtT8X6L__"